import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';

/**
 * MailWorkflowPageComponent — redirector only.
 *
 * The mail list is now rendered INSIDE SkyPlusWorkflowComponent (at /workflow),
 * exactly the same way contracts are. This component exists only because the
 * module router registers '' as the root path, and other components (detail,
 * list's "back" button, completed-task redirect) navigate to '/mail-workflow'
 * which now redirects straight to '/workflow'.
 *
 * You can also change the module route to:
 *   { path: '', redirectTo: '/workflow', pathMatch: 'full' }
 * and delete this file entirely.
 */
@Component({
  selector: 'app-mail-workflow-page',
  template: `<div style="display:flex;align-items:center;justify-content:center;height:100vh">
    <div style="font-size:13px;color:#6c757d">Redirecting…</div>
  </div>`
})
export class MailWorkflowPageComponent implements OnInit {
  constructor(private router: Router) {}

  ngOnInit(): void {
    this.router.navigate(['/workflow'], { replaceUrl: true });
  }
}